<template>
    <div class="container-fluid no-min-height">
        <div class="row">
            <div class="col-12 col-lg-6 offset-lg-3">
                <h2 class="mb-2">{{ formData.title }}</h2>
                <h3 class="mb-2">{{ formData.subTitle }}</h3>

                <div class="position-relative">
                    <transition name="fade">
                        <form v-if="!success" key="form">
                            <h3>Ik wil mij aanmelden voor de:</h3>
                            <RadioInput
                                v-model="form.dayType"
                                v-validate="'required'"
                                data-vv-as="Type dag"
                                :options="[
                                    { name: 'Online Open Dag', checked: true },
                                    {
                                        name: 'Offline Open Dag Alkmaar',
                                        checked: false
                                    }
                                ]"
                                :disabled="processing"
                                :error="errors.first('dayType')"
                                :name="'dayType'"
                            ></RadioInput>

                            <TextInput
                                v-model="form.firstName"
                                v-validate="'required'"
                                data-vv-as="Voornaam"
                                :disabled="processing"
                                :error="errors.first('firstName')"
                                :name="'firstName'"
                                label="Voornaam"
                                placeholder="Voornaam"
                            ></TextInput>
                            <TextInput
                                v-model="form.lastName"
                                v-validate="'required'"
                                data-vv-as="Achternaam"
                                :disabled="processing"
                                :error="errors.first('lastName')"
                                :name="'lastName'"
                                label="Achternaam"
                                placeholder="Achternaam"
                            ></TextInput>
                            <RadioInput
                                v-model="form.gender"
                                v-validate="'required'"
                                data-vv-as="Geslacht"
                                :options="[
                                    { name: 'Man', checked: true },
                                    { name: 'Vrouw', checked: false }
                                ]"
                                :disabled="processing"
                                :error="errors.first('gender')"
                                :name="'gender'"
                                label="Geslacht"
                                placeholder="Geslacht"
                            ></RadioInput>
                            <TextInput
                                v-model="form.email"
                                v-validate="{ required: true, email: true }"
                                data-vv-as="E-mail"
                                :disabled="processing"
                                :error="errors.first('email')"
                                :name="'email'"
                                label="E-mailadres"
                                placeholder="naam@provider.com"
                            ></TextInput>
                            <RadioInput
                                v-model="form.education"
                                v-validate="'required'"
                                data-vv-as="Opleiding"
                                :options="[
                                    { name: 'Vmbo-tl', checked: true },
                                    {
                                        name: 'Havo 5',
                                        checked: false
                                    },
                                    {
                                        name: 'Havo 4/5, 2-jarig traject',
                                        checked: false
                                    },
                                    { name: 'Vwo 6', checked: false }
                                ]"
                                :disabled="processing"
                                :error="errors.first('education')"
                                :name="'education'"
                                label="Opleiding"
                                placeholder="Opleiding"
                            ></RadioInput>
                            <div class="mb-2">
                                <DropdownInput
                                    v-if="
                                        form.education === 'Vmbo-tl' &&
                                            form.dayType === 'Online Open Dag'
                                    "
                                    v-model="form.timeSlot"
                                    :options="timeslotsVmbo"
                                    name="Tijden"
                                    rules="required"
                                />
                                <DropdownInput
                                    v-if="
                                        (form.education === 'Havo 5' ||
                                            form.education === 'Vwo 6') &&
                                            form.dayType === 'Online Open Dag'
                                    "
                                    v-model="form.timeslot"
                                    :options="timeslotsVwo"
                                    name="Tijden"
                                    rules="required"
                                />
                                <DropdownInput
                                    v-if="
                                        form.education ===
                                            'Havo 4/5, 2-jarig traject' &&
                                            form.dayType === 'Online Open Dag'
                                    "
                                    v-model="form.timeSlot"
                                    :options="timeslotsHavo"
                                    name="Tijden"
                                    rules="required"
                                />
                                <DropdownInput
                                    v-if="
                                        form.dayType ===
                                            'Offline Open Dag Alkmaar'
                                    "
                                    v-model="form.timeSlot"
                                    :options="timeslotsOffline"
                                    name="Tijden"
                                    rules="required"
                                />
                            </div>
                            <div class="mb-1">
                                <span
                                    >I.v.m. de coronamaatregelen kun je met
                                    maximaal één ouder/begeleider de Open Dag
                                    bezoeken.</span
                                >
                            </div>
                            <div class="mb-2">
                                <input
                                    id="checkbox"
                                    v-model="privacyAccepted"
                                    rules="required"
                                    type="checkbox"
                                    class="mr-1"
                                />
                                <label for="checkbox">
                                    Ik heb de
                                    <a :href="formData.linkPrivacy.url"
                                        ><u>privacyverklaring</u></a
                                    >
                                    gelezen en ben akkoord.
                                </label>
                            </div>

                            <button
                                class="btn btn-primary float-right mb-1"
                                :disabled="processing"
                                @click.prevent="validateAndSubmit"
                            >
                                Verstuur
                            </button>
                        </form>
                        <div
                            v-else
                            key="successMessage"
                            class="rte"
                            v-html="formData.successMessage"
                        ></div>
                    </transition>
                    <div
                        v-if="!success && error"
                        key="errorMessage"
                        class="rte form-failed"
                        v-html="errorMessageFromApi"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import Axios from 'axios';
import DropdownInput from '@/components/form/dropdown-input';
import FormSubmissionMixin from '@/js/mixins/form-submission-mixin.js';
import TextInput from '@/components/form/text-input';
import RadioInput from '@/components/form/radio-input';

Vue.use(VueReCaptcha, { siteKey: '6LfB5cMUAAAAAOnv1Nn1d1neosmH_X5xVuUx0zu4' });

export default {
    components: {
        TextInput,
        RadioInput,
        DropdownInput
    },

    mixins: [FormSubmissionMixin],

    props: {
        formData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            form: {
                dayType: 'Online Open Dag',
                firstName: '',
                lastName: '',
                gender: 'Man',
                email: '',
                education: 'Vmbo-tl',
                timeSlot: ''
            },
            privacyAccepted: false,
            timeslotsVmbo: [],
            timeslotsHavo: [],
            timeslotsVwo: [],
            timeslotsOffline: [],
            postUrl: '/api/VavoOpenDayFormApi/Submit'
        };
    },
    computed: {
        errorMessageFromApi() {
            return this.errorMessage;
        }
    },
    created() {
        this.getTimeSlots();
    },
    methods: {
        getTimeSlots() {
            const url = '/api/VavoOpenDayFormApi/GetTimeSlots';
            Axios({
                method: 'get',
                url: url
            })
                .then(response => {
                    if (!response.data === null) {
                        return false;
                    }

                    this.timeslotsVmbo = response.data.onlineVmboTimes;
                    this.timeslotsHavo = response.data.onlineHavoTimes;
                    this.timeslotsVwo = response.data.onlineVwoTimes;
                    this.timeslotsOffline = response.data.offlineTimes;

                    return true;
                })
                .catch(() => false);
        }
    }
};
</script>

<style lang="scss"></style>
